<p-table
  [(selection)]="selectedProducts"
  [scrollable]="true"
  [size]="'small'"
  [value]="products()"
  scrollHeight="flex"
  selectionMode="multiple"
  stripedRows>
  <ng-template #header>
    <tr>
      <th style="width: 3rem">
        <p-tableHeaderCheckbox/>
      </th>
      <th pResizableColumn pSortableColumn="nameFr">{{ 'product.name-fr' | translate }}
        <p-sortIcon field="nameFr"/>
      </th>
      <th pResizableColumn pSortableColumn="nameNl">{{ 'product.name-nl' | translate }}
        <p-sortIcon field="nameNl"/>
      </th>
      <th pResizableColumn pSortableColumn="nameEn">{{ 'product.name-en' | translate }}
        <p-sortIcon field="nameEn"/>
      </th>
      <th pResizableColumn pSortableColumn="type">{{ 'product.type' | translate }}
        <p-sortIcon field="type"/>
      </th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template #body let-product>
    <tr (click)="onRowSelect(product)" class="cursor-pointer hover:bg-gray-50">
      <td (click)="$event.stopPropagation()">
        <p-tableCheckbox [value]="product"/>
      </td>
      <td>{{ product.nameFr }}</td>
      <td>{{ product.nameNl }}</td>
      <td>{{ product.nameEn }}</td>
      <td>{{ ('product-type.' + product.type) | translate }}</td>
      <td class="flex justify-end">
        <elcia-button (onClick)="delete($event, product)" [icon]="'delete'" [severity]="'danger'" [variant]="'text'"/>
      </td>
    </tr>
  </ng-template>
</p-table>
